<div class="vs-log-list-expanded-content">
    <div class="vs-log-list-expanded-content__section vs-log-list-expanded-content__section--no-padding-top">
        <vs-log-significance
            *ngIf="isSignificantLog$ | async"
            [significantLog]="significantLog$ | async"
            [compactMode]="true"
        ></vs-log-significance>
        <div class="vs-log-list-expanded-content__communicating-ips">
            <vs-log-communicating-ips></vs-log-communicating-ips>
        </div>
    </div>
    <div class="vs-log-list-expanded-content__section">
        <vs-log-summary-content></vs-log-summary-content>
    </div>

    <cds-button
        size="sm"
        class="vs-log-list-expanded-content__full-log-button"
        (click)="handleViewFullLog()"
    >
        <span class="vs-log-list-expanded-content__full-log-button-label">
            {{ l10nKeys.viewFullLogLabel | vtranslate }}
        </span>
    </cds-button>
</div>
